"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterleavedLine2dHitTestComponent = void 0;
const rc_js_util_1 = require("rc-js-util");
const indexable_point_entity_line_hit_tester_1 = require("../../hit-test/indexable-point-entity-line-hit-tester");
/**
 * @public
 * Inserts line segments into a shared quad tree from a {@link TIndexedPointTrait}.
 */
class InterleavedLine2dHitTestComponent {
    hitTest(entity, indexOfFirstPoint, cssPosition, updateArg) {
        return indexable_point_entity_line_hit_tester_1.IndexablePointEntityLineHitTester.hitTestEntity(entity, indexOfFirstPoint, cssPosition, updateArg);
    }
    index(entity, updateArg, entityTree) {
        const aabb = InterleavedLine2dHitTestComponent.aabb;
        const connector = entity.data;
        const xOffset = entity.data.offsets.x;
        const yOffset = entity.data.offsets.y;
        const groupMask = entity.groupMask;
        const entityId = entity.hitTestId;
        for (let i = connector.getStart(), iEnd = connector.getEnd() - 1; i < iEnd; ++i) {
            aabb[0] = updateArg.interactionTransforms.dataToInteractiveArea.getVec3MultiplyX(connector.getValue(i, xOffset));
            aabb[1] = updateArg.interactionTransforms.dataToInteractiveArea.getVec3MultiplyX(connector.getValue(i + 1, xOffset));
            aabb[2] = updateArg.interactionTransforms.dataToInteractiveArea.getVec3MultiplyY(connector.getValue(i, yOffset));
            aabb[3] = updateArg.interactionTransforms.dataToInteractiveArea.getVec3MultiplyY(connector.getValue(i + 1, yOffset));
            aabb.ensureAABB();
            entityTree.sharedTree.addBoundingBox(aabb, entityId, i, groupMask);
        }
    }
}
exports.InterleavedLine2dHitTestComponent = InterleavedLine2dHitTestComponent;
InterleavedLine2dHitTestComponent.aabb = new rc_js_util_1.Range2d.f32();
//# sourceMappingURL=interleaved-line-2d-hit-test-component.js.map